import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import React, { BaseSyntheticEvent } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import ButtonWallComponent from '../../../../components/buttonWall/ButtonWall.component'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { randomNumber } from '../../../../utilities'
import { getCardiacArrestSelector } from '../selectors'
import { CardiacArrestConstants } from '../store/cardiacArrest.constants'

import './CardiacArrest.page.css'

const CardiacArrest: React.FC = () => {
  const history = useHistory()
  const cardiacArrest = useSelector(getCardiacArrestSelector)
  const {
    endCprButtonClickCount,
    airwayButtonClickCount,
    defibButtonClickCount,
    amiodaroneButtonClickCount,
    epiButtonClickCount,
    atropineButtonClickCount,
    intubationButtonClickCount,
    ivButtonClickCount,
    bvmButtonClickCount,
    endCprButtonSavedTime,
    airwayButtonSavedTime,
    defibButtonSavedTime,
    amiodaroneButtonSavedTime,
    epiButtonSavedTime,
    atropineButtonSavedTime,
  } = cardiacArrest

  const cardiacArrestButtonWall = {
    rows: [
      {
        key: randomNumber().toString(),
        buttons: [
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'End CPR',
              action: CardiacArrestConstants.UPDATE_END_CPR,
              timer: true,
              startTime: { hours: 0, minutes: 1, seconds: 45 },
              savedTime: endCprButtonSavedTime,
              timerDirection: 'down',
              showCount: true,
              count: endCprButtonClickCount,
              color: 'danger',
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Airway',
              action: CardiacArrestConstants.UPDATE_AIRWAY,
              timer: true,
              startTime: { hours: 0, minutes: 0, seconds: 0 },
              savedTime: airwayButtonSavedTime,
              timerDirection: 'up',
              showCount: true,
              count: airwayButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Defib 200 J',
              action: CardiacArrestConstants.UPDATE_DEFIB,
              timer: true,
              startTime: { hours: 0, minutes: 0, seconds: 0 },
              savedTime: defibButtonSavedTime,
              timerDirection: 'up',
              showCount: true,
              count: defibButtonClickCount,
              color: 'success',
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Amiodarone 300mg',
              action: CardiacArrestConstants.UPDATE_AMIODARONE,
              timer: true,
              startTime: { hours: 0, minutes: 0, seconds: 0 },
              savedTime: amiodaroneButtonSavedTime,
              timerDirection: 'up',
              showCount: true,
              count: amiodaroneButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'EPI 1:10,000',
              action: CardiacArrestConstants.UPDATE_EPI,
              timer: true,
              startTime: { hours: 0, minutes: 0, seconds: 0 },
              savedTime: epiButtonSavedTime,
              timerDirection: 'up',
              showCount: true,
              count: epiButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Atropine',
              action: CardiacArrestConstants.UPDATE_ATROPINE,
              timer: true,
              startTime: { hours: 0, minutes: 0, seconds: 0 },
              savedTime: atropineButtonSavedTime,
              timerDirection: 'up',
              showCount: true,
              count: atropineButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Intubation Oral',
              action: CardiacArrestConstants.UPDATE_INTUBATION,
              timer: false,
              showCount: true,
              count: intubationButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'Initiate IV Peripheral',
              action: CardiacArrestConstants.UPDATE_INITIATE_IV,
              timer: false,
              showCount: true,
              count: ivButtonClickCount,
            },
          },
          {
            key: randomNumber().toString(),
            type: 'quickAction',
            props: {
              label: 'BVM',
              action: CardiacArrestConstants.UPDATE_BVM,
              timer: false,
              showCount: true,
              count: bvmButtonClickCount,
            },
          },
        ],
      },
    ],
  }

  const onActionsClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.QUICK_ACTIONS_TAB)
  }

  return (
    <IonPage>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton onClick={onActionsClick} color='primary'>
              <IonIcon icon={chevronBackOutline} />
              Actions
            </IonButton>
          </IonButtons>
          <IonTitle>Cardiac Arrest</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen color='light'>
        <ButtonWallComponent rows={cardiacArrestButtonWall.rows} />
      </IonContent>
    </IonPage>
  )
}

export default CardiacArrest
